<div 
    [innerHTML]="footerDescription" 
    class="trix-content"
></div>